{
  "encuestasatisfaccion": {
    "preguntas": {
      "atencion": "¿Se siente satisfecho(a) con la atención e información brindada al momento de su llegada en las diferentes áreas de recepción de Clínica Dhara?",
      "instalaciones": "¿Las instalaciones físicas de la clínica, el orden y aseo cumplen con sus necesidades y expectativas?",
      "informacion": "¿Recibió información suficiente, comprensible y oportuna durante su estancia en la Clínica?",
      "atencion_salas": "¿Se siente satisfecho(a) con la atención recibida en salas de cirugía?",
      "atencion_hospitalizacion": "¿Se siente satisfecho(a) con la atención recibida en hospitalización?",
      "horario_programado": "¿Se cumplió con el horario programado para su cirugía?",
      "alimentos": "¿Se siente satisfecho con el sabor y presentación de los alimentos recibidos?",
      "derechos_deberes": "¿Recibió información de sus derechos y deberes como paciente?",
      "experiencia_global": "¿Cómo calificaría su experiencia global respecto a los servicios de salud que ha recibido a través de esta IPS?",
      "recomendacion": "¿Recomendaría a sus familiares y amigos esta IPS?",
      "comentario": "¿Desea dejarnos algún comentario adicional sobre su experiencia en la clínica?"
    },
    "opciones": {
      "SI": "Sí",
      "NO": "No",
      "NA": "No aplica",
      "MB": "Muy buena",
      "B": "Buena",
      "R": "Regular",
      "M": "Mala",
      "MM": "Muy mala",
      "DS": "Definitivamente sí",
      "PS": "Probablemente sí",
      "DN": "Definitivamente no",
      "PN": "Probablemente no",
      "felicitacion": "Felicitación",
      "sugerencia": "Sugerencia",
      "queja": "Queja",
      "reclamo": "Reclamo"
    },
    "observacion": "",
    "boton": "Guardar"
  }
}